var a = (o, t, n) => new Promise((c, i) => {
  var f = (e) => {
    try {
      r(n.next(e));
    } catch (s) {
      i(s);
    }
  }, g = (e) => {
    try {
      r(n.throw(e));
    } catch (s) {
      i(s);
    }
  }, r = (e) => e.done ? c(e.value) : Promise.resolve(e.value).then(f, g);
  r((n = n.apply(o, t)).next());
});
import { selfAxios as u } from "@oppein/op-utils";
function l(o) {
  return a(this, null, function* () {
    const {
      data: t
    } = yield u.get(
      "/ucenterapi/uc/internal/user/getUserInfoPageListByCon",
      { params: o }
    );
    return t == null ? void 0 : t.data;
  });
}
export {
  l as getGetUserInfoPageListByCon
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/ucenterapi/uc/internal/user/getUserInfoPageListByCon/get.js
// module id = 1838
// module chunks = 67